import $ from 'jquery'

const initializePage = function ($achievements) {
    const nav = $achievements.find('.entry-content--achievement__nav')

    nav.on('click', function () {
        const currentNav = $(this)
        nav.removeClass('entry-content--achievement__nav--active')
        currentNav.toggleClass('entry-content--achievement__nav--active')

        const contents = $achievements.find('.entry-content--achievement__achiev-container')
        contents.slideUp(250)
        contents.eq(currentNav.index()).slideDown(250)
        $('.entry-content--achievement')[0].scrollIntoView({ behavior: 'smooth' })
    })

    nav.eq(0).click()
}

$('.entry-content--achievement').each(function () {
    initializePage($(this))
})

